(() => {
  'use strict';
  const script = document.querySelector('script[data-forum-customer]');
  if (!script) return;
  const customer = script.dataset.forumCustomer || '';
  const root = document.querySelector('[data-forum-signin-preview]');
  const native = root?.dataset.forumNative === 'true';
  if (root?.dataset.initialized) return;
  if (root) root.dataset.initialized = 'true';
  const key = 'jacobs-community-session-v2';
  const authKey = 'jacobs-community-auth-v1';
  const joinKey = 'jacobs-community-join-v2-' + customer;
  const connectionKey = 'jacobs-community-connection-v1';
  const controls = {};
  for (const name of ['enter', 'logout', 'retry', 'join', 'name', 'consent', 'join-submit', 'check', 'store-login', 'browse', 'existing', 'existing-intro', 'existing-consent', 'existing-start', 'existing-steps', 'existing-code', 'existing-copy', 'existing-profile', 'existing-field', 'existing-complete', 'existing-reset', 'existing-expires', 'existing-disconnect']) controls[name] = root?.querySelector('[data-forum-' + name + ']');
  controls.status = root?.querySelector('[data-forum-session-status]');
  let state = null;
  let busy = false;
  let signingOut = false;
  let waitingForParticipation = false;
  let participationTimer = null;
  let memberGeneration = 0, challenge = null, deniedArea = false;
  const nativeComponent = native ? root?.closest('jl-congregation') : null;
  function identityCurrent(generation = memberGeneration) {
    const record = authRecord();
    return !signingOut && generation === memberGeneration && (!record || (record.stage === 'active' && record.customer === customer));
  }
  function existingProfileUrl(value) {
    try {
      const url = new URL(value);
      const params = url.searchParams;
      const keys = [...params.keys()];
      return url.origin === 'https://community.jacobsregeneration.com' && url.pathname === '/register/register' && !url.username && !url.password && !url.hash && keys.length === 3 && keys.every(key => ['edit', 'embedCookiesBlocked', 'userid'].includes(key) && params.getAll(key).length === 1) && params.get('edit') === '1' && params.get('embedCookiesBlocked') === '1' && /^[1-9]\d{0,15}$/.test(params.get('userid') || '') && Number.isSafeInteger(Number(params.get('userid'))) ? url.href : null;
    } catch { return null; }
  }
  function stopWaitingForParticipation() {
    waitingForParticipation = false;
    if (participationTimer !== null) clearTimeout(participationTimer);
    participationTimer = null;
  }
  function hasNativeContentRoute() {
    if (!nativeComponent) return false;
    const validId = value => /^[1-9]\d{0,15}$/.test(String(value || '')) && Number.isSafeInteger(Number(value));
    const params = new URL(window.location.href).searchParams;
    if (validId(params.get('category')) || validId(params.get('topic'))) return true;
    if (!validId(params.get('parent')) && validId(nativeComponent.dataset.categoryId)) return true;
    const legacy = params.get('wtp') || '';
    return /(?:^|\/)categories\/(?:[^/?]*-)?[1-9]\d*(?:[/?]|$)/.test(legacy) ||
      /(?:^|\/)post\/[^/?]*-[1-9]\d*(?:[/?]|$)/.test(legacy) || /^[a-z0-9][a-z0-9-]*-[1-9]\d*(?:[?]|$)/i.test(legacy);
  }
  function authRecord() {
    try {
      const value = JSON.parse(localStorage.getItem(authKey));
      return value && (value.customer === '' || /^[1-9]\d{0,15}$/.test(value.customer)) && ['active', 'pending'].includes(value.stage) ? value : null;
    } catch { return null; }
  }
  function publishAuth(stage, owner = customer) {
    try { localStorage.setItem(authKey, JSON.stringify({ customer: owner, stage, at: Date.now() })); } catch { /* Sign-out itself does not depend on storage. */ }
  }
  function clearMemberView() {
    stopWaitingForParticipation();
    signingOut = true; state = null; memberGeneration++; challenge = null;
    for (const name of ['enter', 'logout', 'retry', 'join', 'check', 'store-login', 'browse', 'existing', 'existing-disconnect']) if (controls[name]) controls[name].hidden = true;
    if (controls['existing-code']) controls['existing-code'].value = '';
    say('Signing out of your account…');
    document.dispatchEvent(new CustomEvent('jl:community-signing-out'));
  }
  function syncIdentity() {
    const previous = authRecord();
    // A page opened before Shopify has finished signing out must not undo the
    // pending signal or expose a fresh copy of private content in another tab.
    if (previous?.stage === 'pending' && previous.customer === customer && customer) {
      clearMemberView();
      if (controls.logout) { controls.logout.hidden = false; controls.logout.textContent = 'Finish signing out'; }
      return false;
    }
    if (!previous || previous.customer !== customer || previous.stage !== 'active') publishAuth('active');
    return true;
  }
  const ticketValid = value => typeof value === 'string' && /^v1\.[A-Za-z0-9_-]{20,1600}$/.test(value);
  function savedSession() {
    try {
      const value = JSON.parse(localStorage.getItem(key));
      return value && /^[1-9]\d{0,15}$/.test(value.customer) && ticketValid(value.ticket) ? value : null;
    } catch { return null; }
  }
  function say(message) { if (controls.status) controls.status.textContent = message; }
  function validUrl(value, path) {
    try {
      const url = new URL(value);
      if (url.origin !== 'https://community.jacobsregeneration.com' || url.pathname !== path || url.username || url.password || url.hash ||
          !/^[A-Za-z0-9_-]{16,256}$/.test(url.searchParams.get('authtoken') || '')) return null;
      const allowed = path === '/' ? ['authtoken'] : ['authtoken', 'redirect'];
      if ([...url.searchParams.keys()].some(p => !allowed.includes(p) || url.searchParams.getAll(p).length !== 1)) return null;
      if (path !== '/' && !['https://jacobsregeneration.com/account/logout', 'https://jacobsregeneration.com/pages/community'].includes(url.searchParams.get('redirect'))) return null;
      return url.href;
    } catch { return null; }
  }
  function navigate(href) {
    const link = document.createElement('a');
    link.href = href; link.rel = 'noreferrer'; link.referrerPolicy = 'no-referrer'; link.click();
  }
  async function request(path, body, csrf) {
    const options = { credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(30000), headers:{Accept:'application/json'} };
    if (body) {
      options.method = 'POST'; options.headers['Content-Type'] = 'application/json';
      if (csrf) options.headers['X-CSRF-Token'] = csrf;
      options.body = JSON.stringify(body);
    }
    const response = await fetch('/apps/jacobs-community/' + path, options);
    const data = await response.json();
    if (!response.ok) {
      const error = new Error(data?.error?.message || 'Congregation sign-in is temporarily unavailable. Please try again.'); error.code = data?.error?.code;
      throw error;
    }
    return data;
  }
  function mountForum() {
    document.querySelectorAll('template[data-forum-content]').forEach(template => {
      const mount = template.nextElementSibling;
      if (!mount?.hasAttribute('data-forum-mount') || mount.dataset.mounted) return;
      mount.dataset.mounted = 'true';
      const content = template.content.cloneNode(true);
      content.querySelectorAll('script').forEach(old => {
        const fresh = document.createElement('script');
        for (const attr of old.attributes) fresh.setAttribute(attr.name, attr.value);
        fresh.textContent = old.textContent; old.replaceWith(fresh);
      });
      mount.append(content);
    });
  }
  async function signOut(record, endStoreSession) {
    const data = await request('forum-logout', { ticket: record.ticket, endStoreSession });
    const target = validUrl(data.logoutUrl, '/register/logout');
    if (!target) throw new Error('Sign-out could not be completed. Please try again.');
    localStorage.removeItem(key);
    navigate(target);
  }
  async function enter() {
    if (busy || !state?.canEnterForum || !state.forumCsrf) return;
    busy = true; controls.enter.disabled = true; say('Opening your congregation account…');
    try {
      // Check that cross-tab sign-out can be retained before issuing a login.
      localStorage.setItem(key + '-check', '1'); localStorage.removeItem(key + '-check');
      const data = await request('forum-session', { categoryId: '1001643' }, state.forumCsrf);
      if (signingOut) return;
      const target = validUrl(data.loginUrl, '/');
      if (!target || !ticketValid(data.logoutTicket)) throw new Error('Sign-in could not be completed. Please try again.');
      localStorage.setItem(key, JSON.stringify({ customer, ticket: data.logoutTicket }));
      navigate(target);
    } catch (error) { if (!signingOut) { say(error.message); controls.retry.hidden = false; } }
    finally { busy = false; controls.enter.disabled = false; }
  }
  async function refresh() {
    stopWaitingForParticipation();
    if (signingOut || !customer || !controls.status) return;
    for (const name of ['enter', 'retry', 'join', 'check', 'store-login', 'existing', 'existing-disconnect']) if (controls[name]) controls[name].hidden = true;
    controls.logout.hidden = !native && savedSession()?.customer !== customer;
    state = null; say('Checking your account connection…');
    const generation = memberGeneration;
    try {
      const refreshed = await request('session?category=1001643');
      if (!identityCurrent(generation)) return;
      state = refreshed;
      if (!state.authenticated) { publishAuth('active', ''); document.dispatchEvent(new CustomEvent('jl:community-signing-out')); say('You are signed out. Use your store account to return to the congregation.'); controls['store-login'].hidden = false; controls.logout.hidden = true; }
      else if (state.connected && (native || state.canEnterForum)) {
        say(native ? deniedArea ? 'Your congregation account is connected, but this discussion is not available to it. You can retry the discussion or use your existing congregation sign-in below.' : 'Your congregation account is connected.' : 'Your store account is connected to the congregation.'); controls.enter.hidden = native;
        if (controls['existing-disconnect']) controls['existing-disconnect'].hidden = !(state.canDisconnectExisting === true && state.connectionCsrf);
      }
      else if (state.canConnectExisting && state.connectionCsrf && controls.existing) {
        say('Your store sign-in is ready. Verify your existing congregation account to open its member discussions here.');
        controls.existing.hidden = false;
        if (challenge && challenge.expiresAt <= Math.floor(Date.now() / 1000)) challenge = null;
        controls['existing-intro'].hidden = Boolean(challenge); controls['existing-steps'].hidden = !challenge;
      }
      else if (state.canConnect && state.connectionCsrf) {
        say('Choose your public name to join. You will use your store sign-in for future visits.'); controls.join.hidden = false;
        try { const attempt = JSON.parse(localStorage.getItem(joinKey)); if (attempt?.displayName) controls.name.value = attempt.displayName; } catch { /* No saved attempt. */ }
      } else if (state.canCheckConnection && state.connectionCsrf) { say('Your signup has been received. Check its status to continue.'); controls.check.hidden = false; }
      else { say('Use your existing congregation sign-in below. If you need help connecting a new account, please contact us.'); }
    } catch { if (identityCurrent(generation)) { say('We could not check your connection. Please try again.'); controls.retry.hidden = false; } }
  }
  function receiveParticipation(event, failed = false) {
    if (signingOut || event.detail?.customerId !== customer) return;
    const current = authRecord();
    if (current?.stage === 'pending' || (current && current.customer !== customer)) {
      clearMemberView();
      if (current?.stage === 'active') window.location.reload();
      return;
    }
    deniedArea = failed && event.detail?.code === 'discussion_unavailable';
    if (!failed && event.detail.canDisconnectExisting === true && !state?.canDisconnectExisting) { void refresh(); return; }
    if (!waitingForParticipation) {
      if (!failed && event.detail.authenticated === true && event.detail.connected === true) { if (state?.connected) say('You are signed in and ready to take part.'); }
      else if (deniedArea) void refresh();
      return;
    }
    stopWaitingForParticipation();
    if (!failed && event.detail.authenticated === true && event.detail.connected === true) {
      // Native content has already performed the fresh identity/access check.
      // Reuse only its account status, never its posting or hosted-login grants.
      state = { authenticated: true, connected: true };
      for (const name of ['enter', 'retry', 'join', 'check', 'store-login']) controls[name].hidden = true;
      controls.logout.hidden = false;
      say('You are signed in and ready to take part.');
    } else {
      // New/legacy members still need the full onboarding state and CSRF proof.
      void refresh();
    }
  }
  document.addEventListener('jl:community-participation', receiveParticipation);
  document.addEventListener('jl:community-read-failed', event => receiveParticipation(event, true));
  document.addEventListener('jl:community-signing-out', () => {
    memberGeneration++; challenge = null; signingOut = true; state = null; stopWaitingForParticipation();
    if (controls.existing) controls.existing.hidden = true;
    if (controls['existing-disconnect']) controls['existing-disconnect'].hidden = true;
    if (controls['existing-code']) controls['existing-code'].value = '';
  });
  document.addEventListener('jl:community-connection-lost', () => {
    memberGeneration++; challenge = null;
    if (controls['existing-code']) controls['existing-code'].value = '';
    if (!signingOut && customer && controls.status) { state = null; void refresh(); }
  });
  controls.existing?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !identityCurrent() || !state?.canConnectExisting || !state.connectionCsrf) return;
    if (!controls['existing-consent'].checked) { say('Confirm that you want future Shop sign-ins to access your existing congregation account.'); return; }
    const generation = memberGeneration;
    busy = true; controls['existing-start'].disabled = true; say('Preparing your secure connection code…');
    try {
      const data = await request('connect/existing/start', {categoryId:'1001643',consent:true}, state.connectionCsrf);
      if (!identityCurrent(generation)) return;
      const profileUrl = existingProfileUrl(data.profileUrl);
      if (!profileUrl || typeof data.challengeId !== 'string' || !/^[A-Za-z0-9_-]{16,128}$/.test(data.challengeId) || typeof data.code !== 'string' || !/^[A-Za-z0-9_-]{6,128}$/.test(data.code) || !Number.isSafeInteger(data.expiresAt) || data.expiresAt <= Date.now()/1000 || data.expiresAt > Date.now()/1000 + 3600 || data.fieldLabel !== 'Store connection code' || typeof data.connectionCsrf !== 'string' || !/^[A-Za-z0-9._~-]{20,4096}$/.test(data.connectionCsrf)) throw new Error('The connection code could not be prepared. Please try again.');
      state.connectionCsrf = data.connectionCsrf;
      challenge = {id:data.challengeId,expiresAt:data.expiresAt};
      controls['existing-code'].value = data.code; controls['existing-profile'].href = profileUrl; controls['existing-field'].textContent = data.fieldLabel;
      controls['existing-expires'].textContent = `This code expires at ${new Date(data.expiresAt * 1000).toLocaleTimeString([], {hour:'numeric',minute:'2-digit'})}. Keep this tab open while you update your profile.`;
      controls['existing-intro'].hidden = true; controls['existing-steps'].hidden = false;
      say('Copy the code, save it in your congregation profile, then return here to finish connecting.'); controls['existing-code'].focus(); controls['existing-code'].select();
    } catch (error) {
      if (identityCurrent(generation)) {
        if (error.code === 'invalid_csrf') await refresh();
        if (identityCurrent(generation)) say(error.message || 'The connection code could not be prepared. Please try again.');
      }
    }
    finally { busy = false; controls['existing-start'].disabled = false; }
  });
  controls['existing-copy']?.addEventListener('click', async () => {
    if (!challenge || !identityCurrent()) return;
    const generation = memberGeneration;
    try { await navigator.clipboard.writeText(controls['existing-code'].value); if (identityCurrent(generation)) say('Code copied. Open your congregation profile and save it in Store connection code.'); }
    catch { if (identityCurrent(generation)) { controls['existing-code'].focus(); controls['existing-code'].select(); say('Select and copy the connection code, then paste it into your congregation profile.'); } }
  });
  controls['existing-reset']?.addEventListener('click', () => {
    if (busy || !identityCurrent()) return;
    challenge = null; controls['existing-code'].value = ''; controls['existing-steps'].hidden = true; controls['existing-intro'].hidden = false;
    controls['existing-start'].focus(); say('Create a new connection code when you are ready.');
  });
  controls['existing-complete']?.addEventListener('click', async () => {
    if (busy || !identityCurrent() || !challenge || !state?.connectionCsrf) return;
    if (challenge.expiresAt <= Date.now()/1000) { challenge = null; controls['existing-steps'].hidden = true; controls['existing-intro'].hidden = false; say('That code has expired. Create a new connection code and save it in your profile.'); return; }
    const generation = memberGeneration;
    busy = true; controls['existing-complete'].disabled = true; say('Verifying your congregation profile…');
    try {
      const data = await request('connect/existing/complete', {categoryId:'1001643',challengeId:challenge.id}, state.connectionCsrf);
      if (!identityCurrent(generation)) return;
      if (data.connected !== true) throw new Error('Your congregation connection could not be confirmed. Please try again.');
      challenge = null; controls['existing-code'].value = ''; controls.existing.hidden = true; deniedArea = false;
      document.dispatchEvent(new CustomEvent('jl:community-session-changed'));
      await refresh();
    } catch (error) { if (identityCurrent(generation)) say(error.message || 'The connection could not be confirmed. Please try again.'); }
    finally { busy = false; controls['existing-complete'].disabled = false; }
  });
  controls['existing-disconnect']?.addEventListener('click', async () => {
    if (busy || !identityCurrent() || !state?.canDisconnectExisting || !state.connectionCsrf) return;
    const generation = memberGeneration;
    busy = true; controls['existing-disconnect'].disabled = true; say('Disconnecting your congregation account…');
    try {
      const result = await request('connect/existing/revoke', {categoryId:'1001643'}, state.connectionCsrf);
      if (!identityCurrent(generation)) return;
      if (result.revoked !== true) throw new Error('We could not confirm disconnection. Please try again.');
      try { localStorage.setItem(connectionKey, JSON.stringify({customer,action:'disconnected',at:Date.now()})); } catch { /* The server connection is already revoked. */ }
      document.dispatchEvent(new CustomEvent('jl:community-connection-lost'));
    } catch (error) {
      if (identityCurrent(generation)) {
        if (error.code === 'invalid_csrf') await refresh();
        if (identityCurrent(generation)) say(error.message || 'We could not confirm disconnection. Please try again.');
      }
    }
    finally { busy = false; controls['existing-disconnect'].disabled = false; }
  });
  controls.enter?.addEventListener('click', enter);
  controls.browse?.addEventListener('click', () => { mountForum(); controls.browse.hidden = true; });
  controls.retry?.addEventListener('click', refresh);
  controls.join?.addEventListener('submit', async event => {
    event.preventDefault();
    if (busy || !state?.canConnect || !state.connectionCsrf) return;
    const displayName = controls.name.value.trim();
    if (!/^[\p{L}\p{N}][\p{L}\p{N} '\u2019-]{0,39}$/u.test(displayName) || !controls.consent.checked) {
      say('Enter a public name using letters, numbers, spaces, apostrophes or hyphens, and confirm that you want to join.'); return;
    }
    busy = true; controls['join-submit'].disabled = true; say('Creating your congregation account…');
    try {
      let body = JSON.parse(localStorage.getItem(joinKey));
      if (body && body.displayName !== displayName) throw new Error('Please keep the same public name while your first signup is being checked.');
      if (!body) body = { categoryId: '1001643', requestId: crypto.randomUUID(), displayName, consent: true };
      localStorage.setItem(joinKey, JSON.stringify(body));
      const data = await request('connect', body, state.connectionCsrf);
      if (data.connected) localStorage.removeItem(joinKey);
      await refresh();
      if (data.connected) { busy = false; if (native) document.dispatchEvent(new CustomEvent('jl:community-session-changed')); else await enter(); }
    } catch (error) { await refresh(); say(error.message); }
    finally { busy = false; controls['join-submit'].disabled = false; }
  });
  controls.check?.addEventListener('click', async () => {
    if (busy || !state?.connectionCsrf) return;
    busy = true; controls.check.disabled = true;
    try {
      const data = await request('connect/check', { categoryId: '1001643' }, state.connectionCsrf);
      if (data.connected) localStorage.removeItem(joinKey);
      await refresh();
      if (data.connected) { busy = false; if (native) document.dispatchEvent(new CustomEvent('jl:community-session-changed')); else await enter(); }
    } catch (error) { say(error.message); }
    finally { busy = false; controls.check.disabled = false; }
  });
  controls.logout?.addEventListener('click', async () => {
    if (busy) return;
    const record = savedSession();
    if (!customer && !record) return;
    publishAuth('pending'); clearMemberView();
    busy = true; controls.logout.disabled = true;
    try {
      if (record) await signOut(record, true); else navigate('/account/logout');
    }
    catch (error) { say(error.message); controls.retry.hidden = false; controls.retry.onclick = () => window.location.reload(); }
    finally { busy = false; controls.logout.disabled = false; }
  });
  window.addEventListener('pageshow', event => { if (event.persisted) window.location.reload(); });
  window.addEventListener('storage', event => {
    if (event.key === connectionKey) {
      try {
        const change = JSON.parse(event.newValue);
        if (change?.customer === customer && change.action === 'disconnected' && !signingOut) document.dispatchEvent(new CustomEvent('jl:community-connection-lost'));
      } catch { /* Ignore unrelated or malformed tab notifications. */ }
    }
    if (event.key === authKey) {
      const record = authRecord();
      if (record?.stage === 'pending') clearMemberView();
      else if (record?.stage === 'active' && (signingOut || record.customer !== customer)) { clearMemberView(); window.location.reload(); }
    }
    if (event.key === key && (!event.newValue || savedSession()?.customer !== customer)) {
      if (authRecord()?.stage === 'pending') clearMemberView(); else { clearMemberView(); window.location.reload(); }
    }
  });
  (async () => {
    if (!syncIdentity()) return;
    const previous = savedSession();
    if (previous && previous.customer !== customer) {
      try { await signOut(previous, false); }
      catch {
        const message = 'Please finish signing out of the previous congregation account before continuing. Reload this page to try again.';
        if (controls.status) say(message);
        else { const notice = document.createElement('p'); notice.textContent = message; document.querySelector('main')?.prepend(notice); }
      }
      return;
    }
    if (nativeComponent?.signingOut) { clearMemberView(); return; }
    if (customer && controls.status && hasNativeContentRoute()) {
      waitingForParticipation = true;
      controls.logout.hidden = false;
      // The content request times out after 30 seconds. This also covers a
      // missing/failed component script without leaving the account UI stuck.
      participationTimer = setTimeout(() => { if (waitingForParticipation) void refresh(); }, 35000);
      // Deferred asset loading can register this listener after the content
      // response. Its current, same-owner state avoids waiting for a lost event.
      if (!nativeComponent.signingOut && nativeComponent.owner === customer && nativeComponent.session?.loaded === true) {
        receiveParticipation({ detail: { ...nativeComponent.session, customerId: customer } });
      }
      return;
    }
    await refresh();
    if (native) return;
    // The provider scrolls to its iframe on load. Do not let that hide the
    // store sign-in/join step. Direct guest links and existing forum sign-in
    // still open immediately; connected sessions resume their discussions.
    const directGuestLink = !customer && new URL(window.location.href).searchParams.has('wtp');
    if (!root || directGuestLink || state?.connectionReason === 'legacy_account' ||
        (state?.connected && savedSession()?.customer === customer)) mountForum();
    else if (controls.browse) controls.browse.hidden = false;
  })();
})();
